class MenuMobile {

	button = false
	target = false
	closeButton = false
	handleOut = null

	constructor(){

		this.button = document.querySelector( '.menu-toggle' )
		this.target = document.querySelector( '.menu-mobile' )

		if( this.target && this.button ){

			this.handleOut = this.clickOut.bind(this)
			
			this.button.addEventListener( 'click', ( event ) => {
				event.preventDefault()
				this.toggle()
			})

			// Close button
			this.closeButton = this.target.querySelector( 'button.close' )
			this.closeButton.addEventListener( 'click', ( event ) => {
				event.preventDefault()
				this.close()
			})

		}

	}

	clickOut( event ){
		if( 
			!Piki.hasParent( event.target, 'menu-mobile' ) 
			&& 
			!event.target.classList.contains( 'menu-mobile' ) 
			&&
			!Piki.hasParent( event.target, 'menu-toggle' ) 
			&& 
			!event.target.classList.contains( 'menu-toggle' ) 
		){
			this.close()
		}
	}

	toggle(){

		if( this.target.classList.contains( 'opened' ) ){
			this.close()
		}
		else {
			this.open()
		}

	}

	open(){

		this.target.classList.add( 'opened' )
		this.button.classList.add( 'active' )
		
		window.addEventListener( 'click', this.handleOut )

		if( window.innerHeight === this.target.offsetHeight ){
			Piki.lockScroll()
		}
	
	}

	close(){
	
		this.target.classList.remove( 'opened' )
		this.button.classList.remove( 'active' )
		
		window.removeEventListener( 'click', this.handleOut )
		Piki.unlockScroll()
	
	}

}

window.addEventListener( 'DOMContentLoaded', () => {
	new MenuMobile()
});